import { connect } from 'react-redux'
import { getStats, getRecentErrors } from 'modules/redux-gateway'
import { ViewErrorDetailsModal } from '../components'

export default connect((state) => ({
  totalFailure: getStats(state).totalFailure,
  errors: getRecentErrors(state),
}))(ViewErrorDetailsModal)
